import Image from 'next/image';
import Link from 'next/link';
import { FunctionComponent } from 'react';
import Container from '../components/Container';
import Layout from '../layouts/Layout';
import styles from './404.module.scss';

const Error404: FunctionComponent = () => {
    return (
        <Layout title="Page Not Found - Cademy" description="Page not found on Cademy">
            <Container>
                <div className={styles.innerContainer}>
                    <div>
                        <h1>Oops! We can&apos;t find that page.</h1>
                        <h2>Why am I seeing this?</h2>
                        <ul>
                            <li>
                                We cannot access a page on the URL you entered. It may not exist, or
                                the listing might have been removed from our platform.
                            </li>
                            <li>Check the URL for typos.</li>
                            <li>
                                You can check out{' '}
                                <Link href="/">some of our other great offerings</Link>.
                            </li>
                            <li>
                                If you think you are seeing this page in error you can{' '}
                                <a href="mailto:support@cademy.io">reach out to our support team</a>{' '}
                                to report the broken link.
                            </li>
                        </ul>
                    </div>
                    <div className={styles.image_container}>
                        <Image src="/404-owl.png" alt="oops" width={250} height={250} />
                    </div>
                </div>
            </Container>
        </Layout>
    );
};

export default Error404;
